import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Loader from "../CommonLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import CommonAlert from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Breadcrumbs, Typography } from "@mui/material";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Keywordbar from "../Rightsidebar/Keywordbar";


const AutoDeploymentSettings = () => {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const navigate = useNavigate();

  const [faqData, setfaqData] = useState("2");
  const [toggle, setToggle] = useState(false);
  const [initialDateval, SetInitialDateval] = useState([]);

  const [activeTab, setActiveTab] = useState("wordpress");

  // WP States
  const [wpAdminUrl, setWpAdminUrl] = useState("");
  const [wpUsername, setWpUsername] = useState("");
  const [wpPassword, setWpPassword] = useState("");
  const [wpHttpUsername, setWpHttpUsername] = useState("");
  const [wpHttpPassword, setWpHttpPassword] = useState("");

  // Django States
  const [djIpAddress, setDjIpAddress] = useState("");
  const [djPemKey, setDjPemKey] = useState("");
  const [djUsername, setDjUsername] = useState("");
  const [djProjectPath, setDjProjectPath] = useState("");

  const [loading, Setloading] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);

  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [domainNameUrl, setDomainNameUrl] = useState({ domain_name: '', domain_url: '' });

  const GetAutoDeploymentSettings = async (tech) => {
    Setloading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}autodeploy/deploy_settings/?technology=${tech}&user_domain_id=${esodata.domaindata.value.header_selected}`,
        { headers: { Authorization: `${ApiToken}` } }
      ).catch((error) => {
        if (error?.response?.status >= 400 && error?.response?.status < 600) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error || "Error fetching settings");
        } else if (error?.code === "ERR_NETWORK") {
          navigate("/errorpages");
        }
      });
      const settings = response?.data?.settings || {};
      if (tech === "wordpress") {
        setWpAdminUrl(settings.admin_url || "");
        setWpUsername(settings.username || "");
        setWpPassword(settings.password || "");
        setWpHttpUsername(settings.http_username || "");
        setWpHttpPassword(settings.http_password || "");
      } else {
        setDjIpAddress(settings.ip_address || "");
        setDjPemKey(settings.pem_key || "");
        setDjUsername(settings.username || "");
        setDjProjectPath(settings.project_path || "");
      }
    } catch (error) {
    } finally {
      Setloading(false);
    }
  };

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        { headers: { Authorization: `${ApiToken}` } }
      ).catch((error) => {
        if (error?.response?.status >= 400 && error?.response?.status <= 599) {
          navigate('/errorpages');
        } else if (error?.code === "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data?.dor_domain_name && datavalue?.data?.dor_domain_url) {
        setDomainNameUrl({ ...domainNameUrl, domain_name: datavalue?.data?.dor_domain_name, domain_url: datavalue?.data?.dor_domain_url });
      }
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return;
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return;
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return;
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    GetAutoDeploymentSettings(activeTab);
    GetuserDatavalue();
    faqdatafun();
    // eslint-disable-next-line
  }, [activeTab, esodata.domaindata.value.header_selected]);

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=83`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (doaminsectiondatavalue?.data) {

        SetInitialDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }

  const apihandleClose = () => {
    setapiOpen(false);
  };

  const SaveAutoDeploymentSettings = async () => {
    if (first.statusDomain) {
      setcheckD(first.statusDomain);
      return;
    }

    Setloading(true);
    const tech = activeTab;
    const settingsPayload = tech === 'wordpress' ? {
      admin_url: wpAdminUrl,
      username: wpUsername,
      password: wpPassword,
      http_username: wpHttpUsername,
      http_password: wpHttpPassword
    } : {
      ip_address: djIpAddress,
      pem_key: djPemKey,
      username: djUsername,
      project_path: djProjectPath
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}autodeploy/deploy_settings/`,
        {
          technology: tech,
          user_domain_id: esodata.domaindata.value.header_selected,
          settings: settingsPayload
        },
        { headers: { Authorization: `${ApiToken}` } }
      ).catch((error) => {
        if (error?.response?.status >= 400 && error?.response?.status <= 599) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error || "Error saving settings");
        } else if (error?.code === "ERR_NETWORK") {
          navigate("/errorpages");
        }
      });
      setapiOpen(true);
      setapierrorMsg(`${tech === 'wordpress' ? 'WordPress' : 'Django'} settings successfully updated.`);
    } catch (error) {
    } finally {
      Setloading(false);
    }
  };

  const handleReset = () => {
    if (activeTab === "wordpress") {
      setWpAdminUrl(""); setWpUsername(""); setWpPassword(""); setWpHttpUsername(""); setWpHttpPassword("");
    } else {
      setDjIpAddress(""); setDjPemKey(""); setDjUsername(""); setDjProjectPath("");
    }
  };

  const handleToggle = () => {
    setfaqData(faqData === "1" ? "2" : "1");
    setToggle((pre) => !pre);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Auto Deployment Settings</title>
      </Helmet>
      <div className={`over_all_container user_experieceover_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
        <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="light" />
        {loading === true && <Loader />}
        <div className="">
          <Container maxWidth={false} className="dashboard-container">
            <Box className="dashboard-box">
              <Grid container className="dashboard-grid">
                <Grid item xs={12} md={4}>
                  <div>
                    <h1 className="dashboard_header">
                      Auto Deployment Settings
                      <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                    </h1>
                  </div>
                </Grid>
                <Grid item xs={12} md={8}>
                  <div className="top_breadcrumb_menu">
                    <div className="exportpdf_outer">
                      <div className="breadcrumb-wrapper">
                        <CommonBreadCrumb breadcrumbValue={[{ title: 'Settings' }, { title: 'Auto Deployment Settings', activeColor: true }]} />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth={false} className="dashboard-container">
            <Box className="dashboard-box-tab">
              <Grid container className="dashboard-grid">
                <Grid item xs={12} md={6}></Grid>
                <Grid item xs={12} md={6}>
                  <div className="drop_down_button">
                    <button type="button" className={`btn_dashboard ${activeTab !== 'wordpress' ? 'btn-non-active' : ''}`} onClick={() => setActiveTab('wordpress')}>WordPress Settings</button>
                    <button type="button" className={`btn_dashboard ${activeTab !== 'django' ? 'btn-non-active' : ''}`} onClick={() => setActiveTab('django')}>Django Settings</button>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth={false} className="dashboard-container">
            <Box className="grid_table_shodow">
              <Grid container className="dashboard-grid" style={{ padding: "40px 0", background: "#fff!important" }}>
                <Grid item xs={12} md={12}>
                  <div className="cnt_audit_outer_wrap">
                    <div className="user_experince_form_container_wrap">
                      <div className="user_experince_form_container">
                        {activeTab === 'wordpress' ? (
                          <>
                            <div className="form_row">
                              <div className="form_column">
                                <div className="label"><label>Admin URL</label></div>
                                <div><input type="text" value={wpAdminUrl} onChange={(e) => setWpAdminUrl(e.target.value)} className="userexp_input" /></div>
                              </div>
                              <div className="form_column">
                                <div className="label"><label>Username</label></div>
                                <div><input type="text" value={wpUsername} onChange={(e) => setWpUsername(e.target.value)} className="userexp_input" /></div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="form_column">
                                <div className="label"><label>Password</label></div>
                                <div><input type="password" value={wpPassword} onChange={(e) => setWpPassword(e.target.value)} className="userexp_input" /></div>
                              </div>
                              <div className="form_column">
                                <div className="label"><label>HTTP Username</label></div>
                                <div><input type="text" value={wpHttpUsername} onChange={(e) => setWpHttpUsername(e.target.value)} className="userexp_input" /></div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="form_column">
                                <div className="label"><label>HTTP Password</label></div>
                                <div><input type="password" value={wpHttpPassword} onChange={(e) => setWpHttpPassword(e.target.value)} className="userexp_input" /></div>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="form_row">
                              <div className="form_column">
                                <div className="label"><label>IP Address</label></div>
                                <div><input type="text" value={djIpAddress} onChange={(e) => setDjIpAddress(e.target.value)} className="userexp_input" /></div>
                              </div>
                              <div className="form_column">
                                <div className="label"><label>Username</label></div>
                                <div><input type="text" value={djUsername} onChange={(e) => setDjUsername(e.target.value)} className="userexp_input" /></div>
                              </div>
                            </div>
                            <div className="form_row">
                              <div className="form_column">
                                <div className="label"><label>PEM Key</label></div>
                                <div><input type="text" value={djPemKey} onChange={(e) => setDjPemKey(e.target.value)} className="userexp_input" /></div>
                              </div>
                              <div className="form_column">
                                <div className="label"><label>Project Path</label></div>
                                <div><input type="text" value={djProjectPath} onChange={(e) => setDjProjectPath(e.target.value)} className="userexp_input" /></div>
                              </div>
                            </div>
                          </>
                        )}
                        <div className="user_experince_form_button" style={{ gap: "10px", marginTop: "20px" }}>
                          <button className="btn_dashboard" onClick={SaveAutoDeploymentSettings}>Save</button>
                          <button className="btn_dashboard" style={{ cursor: "pointer" }} onClick={handleReset}>Reset</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Container maxWidth={false} className="footer-container">
            <Box className="footer-box">
              <Grid container className="footer-grid">
                <Grid item xs={12} md={6}>
                  <div className="footer-left">
                    <p className="footer-text">
                      All Rights Reserved Copyright © 2026 |
                      <a href="https://www.egrovesys.com/" target="_blank" rel="noreferrer"> <span className="footer-brand">Elite site Optimizer</span></a>
                    </p>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="footer-right"></div>
                </Grid>
              </Grid>
            </Box>
          </Container>

          {toggle && <Keywordbar close={() => setToggle(false)} setToggle={setToggle} initialDateval={initialDateval} />}
        </div>
        <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
        {!openCommonAlerts && (
          <CommonErrorAlert
            data={{ apiopen: apiopen, apiErrorMsg: apierrorMsg, isIconStyled: true }}
            closeAlert={apihandleClose}
          />
        )}
      </div>

      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header"><ReportProblemIcon fontSize="large" sx={{ color: '#ff601f' }} /></DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '15px', lineHeight: '1px', width: "max-content" }}>
              <p>{"Please verify your domain ("}<a href={domainNameUrl.domain_url} title={`go to this link ${domainNameUrl.domain_url}`} >{domainNameUrl.domain_name}</a>{") to access these features"}</p>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
      <UserActivityTracker pagename="Settings - Auto Deployment Settings" />
    </>
  );
};

export default AutoDeploymentSettings;
